var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49906 19.1414L3.4863 20.8466C3.69144 21.2056 3.98633 21.4877 4.33251 21.6928L7.85837 15.5898H0.806641C0.806641 15.9873 0.909211 16.3848 1.11435 16.7438L2.49906 19.1414Z",
    fill: "#0066DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 8.41155L8.4738 2.30859C8.12762 2.51374 7.83273 2.7958 7.62759 3.1548L1.11435 14.4376C0.912984 14.7888 0.806909 15.1866 0.806641 15.5915H7.85837L11.9997 8.41155Z",
    fill: "#00AC47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.667 21.6928C20.0132 21.4877 20.3081 21.2056 20.5132 20.8466L20.9235 20.1414L22.8852 16.7438C23.0903 16.3848 23.1929 15.9873 23.1929 15.5898H16.1406L17.6412 18.5388L19.667 21.6928Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 8.41067L15.5263 2.30771C15.1802 2.10257 14.7827 2 14.3724 2H9.62853C9.21825 2 8.82079 2.11539 8.47461 2.30771L12.0005 8.41067Z",
    fill: "#00832D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1405 15.5898H7.8579L4.33203 21.6928C4.67821 21.8979 5.07567 22.0005 5.48595 22.0005H18.5124C18.9227 22.0005 19.3202 21.8851 19.6663 21.6928L16.1405 15.5898Z",
    fill: "#2684FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6287 8.79619L16.3721 3.1548C16.1669 2.7958 15.872 2.51374 15.5259 2.30859L12 8.41155L16.1413 15.5915H23.1802C23.1802 15.194 23.0776 14.7966 22.8725 14.4376L19.6287 8.79619Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.47272c82fbf3195da308e6635d7cd8fc.svg";
export { ForwardRef as ReactComponent };